/*
 *
 * AccountPage
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import Wrapper from './Wrapper';
import FormTabs from 'components/FormTabs';
import AccountForm from './Forms/AccountForm'
import { selectUser } from 'containers/App/selectors'
import { patchAccountRequest } from './actions'

export class AccountPage extends React.Component {

  render() {
    const { user, patchAccount } = this.props;

    if(!user || user.email === '') {
      return <div></div>
    }

    const formsObj = {
      BASIC_INFO: {
        disabled: false,
        title: 'ACCOUNT',
        renderForm: () =>
          <AccountForm
            initialValues={user}
            handleSubmit={patchAccount}
          />
      }
    }

    const tabs = [ formsObj['BASIC_INFO'] ]

    return (
      <Wrapper>
        <Helmet
          title="AccountPage"
          meta={[
            { name: 'description', content: 'Description of AccountPage' },
          ]}
        />
        {
          user
            ?
            <FormTabs
              formTitle="My Account"
              currentTab={0}
              tabs={tabs}
            />
            :
            undefined
        }
      </Wrapper>
    );
  }
}

const mapStateToProps = (state) => createStructuredSelector({
  user: selectUser(),
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  patchAccount: (data) => {
    dispatch(patchAccountRequest(data))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountPage);



// WEBPACK FOOTER //
// ./src/containers/AccountPage/index.js